<template>
  <span class="breadcrumb-item">
    <span :class="['breadcrumb-inner', to ? 'is-link' : '']" ref="link" role="link">
      <slot></slot>
    </span>
    <i v-if="separatorClass" class="breadcrumb-separator" :class="separatorClass"></i>
    <span v-else class="breadcrumb-separator" role="presentation">{{separator}}</span>
  </span>
</template>

<script>
  export default {
    name: 'MyBreadcrumbItem',
    props: {
      to: {},
      replace: Boolean
    },
    data() {
      return {
        separator: '',
        separatorClass: ''
      };
    },
    inject: ['myBreadcrumb'],
    mounted() {
      this.separator = this.myBreadcrumb.separator;
      this.separatorClass = this.myBreadcrumb.separatorClass;
      const link = this.$refs.link;
      link.setAttribute('role', 'link');
      link.addEventListener('click', _ => {
        const { to, $router } = this;
        if (!to || !$router) return;
        this.replace ? $router.replace(to) : $router.push(to);
      });
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/common/breadcrumb/breadcrumb-item.vue